<app-ice-card>
  <div class="return-mobile-container">
    <span class="graphic-wrapper">
      @if (image) {
        <img [src]="image" />
      } @else {
        <mat-icon matListIcon [svgIcon]="icon" />
      }
    </span>
    <span class="text-wrapper">
      <div class="title">{{ title }}</div>
      <div class="name">
        {{ mobilePhoneName }}
      </div>
      @if (mobilePhoneImei) {
        <div>
          <span class="imei">
            <span class="label">IMEI:</span>
            {{ mobilePhoneImei }}
          </span>
        </div>
      }
      @if (!!insuranceName) {
        <app-ice-badge class="insurance" type="info">
          <b>{{ insuranceName }}</b>
          @if (!!insurancePrice) {
            <span>{{ insurancePrice | priceFormat: PriceType.Monthly }}</span>
          }
        </app-ice-badge>
      }
    </span>
  </div>
</app-ice-card>
